
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"13","viewBox":"0 0 7 9","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.206 8.25a.673.673 0 01-.5-.229A.824.824 0 01.5 7.47V1.53c0-.207.074-.405.207-.551A.673.673 0 011.206.75c.187 0 .367.082.499.229a.824.824 0 01.207.551v5.94a.824.824 0 01-.207.551.674.674 0 01-.5.229zm4.588 0a.674.674 0 01-.499-.229.824.824 0 01-.207-.551V1.53c0-.207.075-.405.207-.551a.674.674 0 01.5-.229c.186 0 .366.082.498.229a.824.824 0 01.207.551v5.94a.824.824 0 01-.207.551.673.673 0 01-.499.229z","fill":"#fff"}})])
          )
        }
      }
    